interface TagProps {
  children: string;
  selected?: boolean;
  onClick?: () => void;
  variant?: 'pill' | 'chip';
  small?: boolean;
  compact?: boolean;
}

export default function Tag({
  children,
  selected = false,
  onClick,
  variant = 'pill',
  small = false,
  compact = false,
}: TagProps) {
  const isPill = variant === 'pill';
  const isInteractive = onClick !== undefined;

  const baseStyles = 'rounded-[16px] font-medium whitespace-nowrap';

  const sizeStyles = compact
    ? 'px-2.5 py-1 text-[12px]'
    : small
    ? 'px-2 py-1 text-[10px]'
    : 'px-3 py-1.5 text-[13px]';

  const colorStyles = selected
    ? 'bg-[#40E0D0] text-[#031414] border border-[#40E0D0]'
    : 'bg-transparent border border-[#40E0D0] text-[#A0A0A0]';

  const interactiveStyles = isInteractive
    ? 'cursor-pointer hover:opacity-80 transition-all duration-200 active:scale-95'
    : '';

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (onClick) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }
  };

  return (
    <div
      className={`inline-block ${baseStyles} ${sizeStyles} ${colorStyles} ${interactiveStyles}`}
      onClick={handleClick}
    >
      {children}
    </div>
  );
}
